import getters from "./getters.js";
import actions from "./actions.js";
import mutations from "./mutations.js";

export default {
    namespaced: true,
    state: {
        searchFriend: []
    },
    getters: getters,
    mutations: mutations,
    actions: actions
}
